//export const API_BASE_LOCAL_URL = "http://localhost:8080";
export const API_BASE_LOCAL_URL = "https://api.orgavitaz.com";

// reCAPTCHA public key (same for login + register)
export const RECAPTCHA_SITE_KEY = "6LfSamEsAAAAAO7zuOchG2FkAb0I2Fc562lBDu_J";

// Google OAuth endpoint
export const GOOGLE_AUTH_URL = `${API_BASE_LOCAL_URL}/oauth2/authorization/google`;

// captcha verify endpoint (backend)
export const CAPTCHA_VERIFY_URL = `${API_BASE_LOCAL_URL}/api/public/captcha/verify`;